import { FLAPPY_HEIGHT, FLAPPY_WIDTH, flappyConfig } from "./flappy-config";
import type { FlappyEngine } from "./flappy-engine";

export class FlappyRenderer {
  private readonly context: CanvasRenderingContext2D;

  constructor(private readonly canvas: HTMLCanvasElement) {
    this.context = canvas.getContext("2d")!;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(FLAPPY_WIDTH * dpr);
    canvas.height = Math.round(FLAPPY_HEIGHT * dpr);
    canvas.style.width = `${FLAPPY_WIDTH}px`;
    canvas.style.height = `${FLAPPY_HEIGHT}px`;
    this.context.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.context.imageSmoothingEnabled = true;
  }

  render(engine: FlappyEngine, sprite?: HTMLImageElement, background?: HTMLImageElement, obstacle?: HTMLImageElement): void {
    const ctx = this.context;
    ctx.clearRect(0, 0, FLAPPY_WIDTH, FLAPPY_HEIGHT);
    if (background) {
      ctx.drawImage(background, 0, 0, FLAPPY_WIDTH, FLAPPY_HEIGHT);
    } else {
      const gradient = ctx.createLinearGradient(0, 0, 0, FLAPPY_HEIGHT);
      gradient.addColorStop(0, "#2b2868");
      gradient.addColorStop(1, "#f3b69d");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, FLAPPY_WIDTH, FLAPPY_HEIGHT);
    }

    engine.obstacles.forEach((item) => {
      const bottomY = item.gapY + flappyConfig.obstacleGap;
      if (obstacle) {
        ctx.drawImage(obstacle, item.x, 0, flappyConfig.obstacleWidth, item.gapY);
        ctx.drawImage(obstacle, item.x, bottomY, flappyConfig.obstacleWidth, FLAPPY_HEIGHT - bottomY);
      } else {
        ctx.fillStyle = "#6bd2a2";
        ctx.fillRect(item.x, 0, flappyConfig.obstacleWidth, item.gapY);
        ctx.fillRect(item.x, bottomY, flappyConfig.obstacleWidth, FLAPPY_HEIGHT - bottomY);
      }
    });

    const player = engine.player;
    if (sprite) {
      ctx.drawImage(sprite, player.x, player.y, flappyConfig.playerSize, flappyConfig.playerSize);
    } else {
      ctx.fillStyle = "#ff8ebc";
      ctx.beginPath();
      ctx.arc(player.x + 24, player.y + 24, 21, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.fillStyle = "rgba(16, 13, 46, 0.16)";
    ctx.fillRect(0, flappyConfig.groundY, FLAPPY_WIDTH, FLAPPY_HEIGHT - flappyConfig.groundY);
  }
}
